import request from '@/utils/request'
import axios from 'axios'
const host = process.env.VUE_APP_USER_API;
const orderhost = process.env.VUE_APP_ORDER_API;
const hostmms = process.env.VUE_APP_MARKETING_API;
//登陆
export function login(data) {
  return request({
    url: host+'member/login',
    method: 'post',
    data:data
  })
}
//获取用户信息
export function getInfo(token) {
  return request({
    url: '/vue-admin-template/user/info',
    method: 'get',
    params: { token }
  })
}
//退出登陆
export function logout() {
  return request({
    url: '/vue-admin-template/user/logout',
    method: 'post'
  })
}
//发送手机验证码
export function sendSms(params) {
  return request({
    url: host+'validate/sendSms',
    method: 'post',
    params
  })
}
//用户注册
export function register(data) {
  return request({
    url: host+'member/register',
    // url: 'http://umsapi.fat.gemsf.cn/'+'member/register',
    method: 'post',
    data:data
  })
}
//检验手机是否已注册
export function mobileIsExist(params) {
  return request({
    url: host+'member/mobileIsExist',
    method: 'get',
    params
  })
}

//修改密码
export function reset(data) {
  return request({
    url: host+'member/reset',
    method: 'post',
    data:data
  })
}
//已登录状态修改密码
export function resets(data) {
  return request({
    url: host+'member/reset2',
    method: 'post',
    data:data
  })
}
//获取用户地址列表
export function address(params) {
  return request({
    url: host+'address',
    method: 'get',
    params
  })
}
//新增地址
export function addAddress(data) {
  return request({
    url: host+'address',
    method: 'post',
    data:data
  })
}
//修改地址
export function putAddress(data) {
  return request({
    url: host+'address',
    method: 'put',
    data:data
  })
}
//删除地址
export function delAddress(params) {
  return request({
    url: host+'address/'+params,
    method: 'delete',
  })
}
//根据id查询地址
export function searchAddress(params) {
  return request({
    url: host+'address/'+params,
    method: 'get',
  })
}
//查询用户个人信息
export function getUserInfo() {
  return request({
    url: host+'/member',
    method: 'get',
  })
}
//修改个人信息
export function changeUserInfo(data) {
  return request({
    url: host+'/member',
    method: 'put',
    data:data
  })
}
// 查询用户发票抬头信息
export function searchUserInvoiceHead() {
  return request({
    url: host+'invoice/searchUserInvoiceHead',
    method: 'get'
  })
}
// 提交用户发票抬头信息
export function saveUserInvoiceHead(data) {
  return request({
    url: host+'invoice/saveUserInvoiceHead',
    method: 'post',
    data:data
  })
}
// 删除用户发票抬头信息
export function delUserInvoice(params) {
  return request({
    url: host+'invoice/delUserInvoice',
    method: 'post',
    params
  })
}
// 修改用户发票抬头信息1
export function editUserInvoiceHead(params) {
  return request({
    url: host+'invoice/editUserInvoiceHead',
    method: 'post',
    params
  })
}
// 设置默认的发票抬头
export function setDefaultUserInvoice(params) {
  return request({
    url: host+'invoice/setDefaultUserInvoice',
    method: 'post',
    params
  })
}
// 修改用户发票纳税人信息
export function editUserInvoice(params) {
  return request({
    url: host+'invoice/editUserInvoice',
    method: 'post',
    params
  })
}
// 查询订单页面用户默认的发票抬头信息
export function searchUserDefaultInvoiceHead() {
  return request({
    url: host+'invoice/searchUserDefaultInvoiceHead',
    method: 'get'
  })
}
// 查询订单页面增值税发票抬头信息
export function searchUserGSTInvoiceHead() {
  return request({
    url: host+'invoice/searchUserGSTInvoiceHead',
    method: 'get'
  })
}
// 新增企业信息
export function addEnterprise(data) {
  return request({
    url: host+'enterprise',
    method: 'post',
    data:data
  })
}
// 查询用户关联企业信息
export function searchEnterprisemember() {
  return request({
    url: host+'enterprisemember/getEnterpriseMemberList',
    method: 'get'
  })
}
// 查询用户审核通过的企业信息
export function getApprovedEnterpriseListt() {
  return request({
    url: host+'enterprisemember/getApprovedEnterpriseList',
    method: 'get'
  })
}
export function getApprovedEnterpriseList() {
  return request({
    url: host+'enterprisemember/getApprovedEnterpriseOne',
    method: 'get'
  })
}
// 用户切换企业
export function changeEnterpise(params) {
  return request({
    url: host+'enterprisemember/changeEnterpise',
    method: 'post',
    params
  })
}
// 邀请用户绑定企业
export function saveMemberEnterprise(params) {
  return request({
    url: host+'enterprisemember/saveMemberEnterprise',
    method: 'post',
    params
  })
}
// 查询企业的地址信息
export function getEnterpriseAddress(params) {
  return request({
    url: host+'enterprisemember/getEnterpriseAddress',
    method: 'get',
    params
  })
}
// 查询企业的发票和收票信息
export function getEnterpriseInvoice(params) {
  return request({
    url: host+'enterprisemember/getEnterpriseInvoice',
    method: 'get',
    params
  })
}
// 查询企业用户角色信息
export function getEnterpriseRoleName() {
  return request({
    url: host+'enterprisemember/getEnterpriseRoleName',
    method: 'get'
  })
}
// 查询企业下的用户信息
export function getEnterpriseMemberAndRole(params) {
  return request({
    url: host+'enterprisemember/getEnterpriseMemberAndRole',
    method: 'get',
    params
  })
}
// 修改企业下的用户角色
export function updateEnterpriseMemberRole(params) {
  return request({
    url: host+'enterprisemember/updateEnterpriseMemberRole',
    method: 'post',
    params
  })
}
// 注销企业
export function delEnterprise(params) {
  return request({
    url: host+'enterprisemember/delEnterprise',
    method: 'post',
    params
  })
}
// 修改企业下的用户操作状态
export function updateEnterpriseMemberStatus(params) {
  return request({
    url: host+'enterprisemember/updateEnterpriseMemberStatus',
    method: 'post',
    params
  })
}
// 设置默认的企业发票抬头
export function setDefaultEnterpriseUserInvoice(params) {
  return request({
    url: host+'enterprisemember/setDefaultEnterpriseUserInvoice',
    method: 'post',
    params
  })
}
// 设置默认的企业的收货地址信息
export function setDefaultEnterpriseUserAddress(params) {
  return request({
    url: host+'enterprisemember/setDefaultEnterpriseUserAddress',
    method: 'post',
    params
  })
}
// 保存自定义编码
export function saveCustomEncoding(params) {
  return request.post(orderhost+'customEncoding/saveCustomEncoding',params)
}
// 商品详情页面查询自定义编码
export function searchCustomEncodingByProductDetail(params) {
  return request.post(orderhost+'customEncoding/searchCustomEncodingByProductDetail',params)
}
// 商品详情页面查询自定义编码
export function searchCustomEncoding(params) {
  return request.post(orderhost+'customEncoding/searchCustomEncoding',params)
}
export function delCustomEncoding(params) {
  return request.post(orderhost+'customEncoding/delCustomEncoding',params)
}
//运输方式
export function getEnterpriseStock(params) {
  return request.get(host+`enterprisemember/getEnterpriseStock?erpCode=${params}`)
}
//
export function getHomeBannerByType(params) {
  return request.get(hostmms+`banner/getHomeBannerByType?type=${params}`)
}
//查询授权
export function getAuthorizedByID(params) {
  return request.get(host + `ums-auth-orized-agency/getAuthorizedByID`,{params})
}

//查询省市区县
export function queryAllProvinceByCode(params) {
  return request.get(hostmms + `lgs-charge/queryAllProvinceByCode`, { params })
}
//查询客户是否可以下单
export function getVerificationMemberAndEnterprise(params) {
  return request.get(host + `/enterprisemember/getVerificationMemberAndEnterprise`, { params })
}
//查询支付方式
export function getMemberEnterpriseAndPayType(params) {
  return request.get(host + `/enterprisemember/getMemberEnterpriseAndPayType`)
}


// WEBPACK FOOTER //
// ./src/api/user.js